import "../../assets/styles/product-view.css";
import React, { useEffect } from "react";
import image from "../../assets/images/clearcustoms_banner.jpeg";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import Banner from "../../components/Banner/Banner";
import product_image from "../../assets/images/ClearCustoms.jpg";
import { FormattedMessage } from "react-intl";
import en_locale from "../../translations/en.json";
import de_locale from "../../translations/de.json";
import { useDispatch, useSelector } from "react-redux";
import Team from "../../components/Team/Team";
import MatchingProducts from "../../components/MatchingProducts/MatchingProducts";
import { useNavigate, useParams } from "react-router-dom";
import { setLang } from "../../redux/actions/settings";

const ClearCustoms = () => {
  const lang = useSelector((state) => state.settings.lang);
  const messages = {
    de: de_locale,
    en: en_locale,
  };
  window.scrollTo(0, 0);

  const { language } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (language === "de" || language === "en") {
      dispatch(setLang(language));
    } else {
      navigate("/not-found");
    }
  }, []);

  useEffect(() => {
    document.title =
      lang === "de"
        ? "ClearCustoms - Grenzfreier Handel"
        : "ClearCustoms - Border-free commerce";
  }, [lang]);
  return (
    <div>
      <div>
        <BreadCrumbs
          navItems={[
            {
              title: "eClear Store",
              href: `/store/${language}`,
            },
            {
              title: "Customs Suite",
              href: `/store/${language}/customs-suite`,
            },
            {
              title: "ClearCustoms",
            },
          ]}
        />
      </div>
      <div>
        <div>
          <div className="column main">
            <Banner
              image={image}
              title={"ClearCustoms"}
              productImage={product_image}
            />
            <input
              name="form_key"
              type="hidden"
              defaultValue="Sk3VlxqpWwfVfRQk"
            />
            <div
              id="authenticationPopup"
              data-bind="scope:'authenticationPopup', style: {display: 'none'}"
              style={{ display: "none" }}
            ></div>
            <div className="catalog-product-view ">
              <div className="product-infomation-wrapper">
                <input type="hidden" id="storeId" defaultValue={1} />
                <input type="hidden" id="currencySymbol" defaultValue="€" />
                <div className="product-information">
                  <div className="box-left">
                    <div className="use-case">
                      <h3 className="title">Use case</h3>
                      <FormattedMessage id="ClearCustoms.useCase" />
                    </div>
                    <div className="features-and-benefits">
                      <div className="features">
                        <h3 className="title">Feature</h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage id="ClearCustoms.feature1" />
                          </li>
                          <li>
                            <FormattedMessage id="ClearCustoms.feature2" />
                          </li>
                          <li>
                            <FormattedMessage id="ClearCustoms.feature3" />
                          </li>
                        </ul>{" "}
                      </div>
                      <div className="benefits">
                        <h3 className="title">Benefit</h3>
                        <h3 className="sub-title" style={{ fontWeight: 400 }}>
                          <FormattedMessage
                            id="ClearCustoms.benefit.section1"
                            values={{
                              sup: (...chunks) => {
                                return <sup>{chunks}</sup>;
                              },
                            }}
                          />
                        </h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage id="ClearCustoms.benefit1.1" />
                          </li>
                          <li>
                            <FormattedMessage id="ClearCustoms.benefit1.2" />
                          </li>
                          <li>
                            <FormattedMessage id="ClearCustoms.benefit1.3" />
                          </li>
                        </ul>
                        <h3 style={{ fontWeight: 400 }} className="sub-title">
                          <FormattedMessage
                            id="ClearCustoms.benefit.section2"
                            values={{
                              sup: (...chunks) => {
                                return <sup>{chunks}</sup>;
                              },
                            }}
                          />
                        </h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage id="ClearCustoms.benefit2.1" />
                          </li>
                          <li>
                            <FormattedMessage id="ClearCustoms.benefit2.2" />
                          </li>
                          <li>
                            <FormattedMessage id="ClearCustoms.benefit2.3" />
                          </li>
                        </ul>
                      </div>
                    </div>
                    <Team />
                  </div>
                  <div className="box-right">
                    {/* REQUEST BUTTON */}
                    <form action={messages[lang]["ContactLink"]} method="get">
                      <div className="box-to-cart">
                        <span>
                          <FormattedMessage id="Request quotation" />
                        </span>
                        <button
                          className="action subscribe primary request-demo-now-header"
                          type="submit"
                        >
                          <FormattedMessage id="Reuqest offer" />
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <MatchingProducts />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ClearCustoms;
